import { root } from './web-plans';

export const webPlans = {
  ...root,
};
